import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"

import { useAuth } from "@/hooks/useAuth"
import { LoginForm } from "@/components/features/admin/LoginForm"

type ProtectedRouteProps = {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return <div>Chargement...</div>
  return isAuthenticated ? <>{children}</> : <Navigate to="/admin" replace />
}

export const AdminGate = () => {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return <div>Chargement...</div>
  return isAuthenticated ? <Navigate to="/admin/dashboard" replace /> : <LoginForm />
}
